import React, { useEffect } from "react";
import styles from "./Payment.module.css";
import { CheckBox } from "../../../helbest";
import { useTranslation } from "react-i18next";
import { ReactComponent as PlusIcon } from "../../../assets/svg/plus.svg";
import Item from "../../components/Delivery/NewAddresses/Item/Item";
import PaymentBillingAddress from "../../components/Payment/PaymentBillingAddress/PaymentBillingAddress";
import { AddressItemTransformer } from "../../../services/objectTransformer/address";
import { useSelector } from "react-redux";

const BillingAddress = ({
  checkoutData,
  changeBillingAddress,
  checkoutBillingAddressUpdateMutation,
  setChangeBillingAddress,
  selectedAddress,
  setShowAddressPopup,
  setSelectedAddress,
  showAddressPopup,
}) => {
  const { t } = useTranslation();
  const checkoutInfo = checkoutData?.checkout ?? {};
  const store = useSelector((state) => state);

  const billingAddress = checkoutData
    ? AddressItemTransformer(checkoutInfo?.billingAddress)
    : {};

  useEffect(() => {
    !changeBillingAddress &&
      checkoutBillingAddressUpdateMutation({
        variables: {
          id: store.Login.checkoutId,
          billingAddress: billingAddressInfo,
          validationRules: { checkRequiredFields: false },
        },
      });
  }, [changeBillingAddress]);

  const shippingAddressInfo = checkoutData
    ? AddressItemTransformer(checkoutInfo?.shippingAddress)
    : {};

  const billingAddressInfo = {
    streetAddress1: shippingAddressInfo?.address,
    streetAddress2: shippingAddressInfo.details,
    companyName: shippingAddressInfo.company_name,
    postalCode: shippingAddressInfo.postal_code,
    phone: shippingAddressInfo.phone,
    firstName: shippingAddressInfo.firstName,
    lastName: shippingAddressInfo.lastName,
    country: shippingAddressInfo?.country,
    countryArea: shippingAddressInfo?.region,
    city: shippingAddressInfo?.city,
    metadata: shippingAddressInfo?.location
      ? [
          {
            key: "location",
            value: `${shippingAddressInfo?.location?.lng}, ${shippingAddressInfo?.location?.lat}`,
          },
        ]
      : [],
  };

  return (
    <div>
      <div className={styles.BoxTitle}>{t("addresses.billing_address")}</div>
      <div className={styles.BillingAddressCheckbox}>
        <CheckBox
          checked={!changeBillingAddress}
          onChange={(event) => {
            setChangeBillingAddress(!event.target.checked);
            if (event.target.checked) {
              setSelectedAddress("");
            }
          }}
        >
          {t("address_map.use_address")}
        </CheckBox>
      </div>
      {changeBillingAddress && checkoutData && selectedAddress !== "" && (
        <Item
          {...selectedAddress}
          active={true}
          // last={addressIndex === addresses.length - 1}
          key={selectedAddress.id}
        />
      )}
      <div
        className={styles.AddAddressButton}
        onClick={() => changeBillingAddress && setShowAddressPopup(true)}
        style={{
          ...(!changeBillingAddress && { cursor: "not-allowed", opacity: 0.4 }),
        }}
      >
        <div className={styles.AddAddressButtonIconContainer}>
          <PlusIcon />
        </div>
        <span>{t("address_map.select_address")}</span>
      </div>
      <PaymentBillingAddress
        openBillingAddress={showAddressPopup}
        shippingAddress={checkoutInfo?.shippingAddress}
        billingAddress={billingAddress}
        selectedAddress={selectedAddress}
        setSelectedAddress={setSelectedAddress}
        checkoutId={store.Login.checkoutId}
        onSubmit={(variables) =>
          checkoutBillingAddressUpdateMutation({
            variables,
          })
        }
        onClose={() => setShowAddressPopup(false)}
      />
    </div>
  );
};

export default BillingAddress;
